<div fxFlex fxFlexFill fxLayoutAlign="{{ align }} center">
  <nz-spin fxFlex fxFlexFill fxLayoutAlign="{{ align }} center" [nzSpinning]="loading">
    <div class="image-container" fxLayoutAlign="{{ align }} center">
      <img *ngIf="currentImageUrl !== null" alt="img" [src]="currentImageUrl | safeUrl" [style.maxWidth]="maxWidth" />
    </div>
  </nz-spin>
</div>
